module.exports = __webpack_public_path__ + "img/LTE:ERR - WLAN:ERR.58f48bf8.jpg";